class FooterCta {
  constructor(contentfulNode) {
    this.title = contentfulNode?.title;
    this.body = contentfulNode?.body;
    this.primaryButtonText = contentfulNode?.primaryButtonText;
    this.primaryButtonUrl = contentfulNode?.primaryButtonUrl;
    this.secondaryButtonText = contentfulNode?.secondaryButtonText;
    this.secondaryButtonUrl = contentfulNode?.secondaryButtonUrl;
  }
}

export default FooterCta